import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

export type BaseTimeMode = 'at' | 'by' | 'default';

export type FormattedTimeConfig = {
  options: TimeOptions;
  time: Date;
};

export type TimeOptions = { display: 'full' } | { display: 'hidden' } | { display: 'time'; mode: BaseTimeMode };

type P = {
  timeConfig: FormattedTimeConfig;
};

// TODO: this should be component, rethink structure of these components
const renderTimeText = ({ mode, t, time }: { mode: BaseTimeMode; t: TFunction; time: Date }) => {
  switch (mode) {
    case 'at':
      return t('time_tag_at', { date: time });
    case 'by':
      return t('time_tag_by', { date: time });
    case 'default':
      return t('dateFormats.time', { date: time });
  }
};

const WidgetItemTimeText = ({ timeConfig: { options, time } }: P) => {
  const { t } = useTranslation();

  switch (options.display) {
    case 'full':
      return t('dateFormats.dateTime', { date: time });
    case 'hidden':
      return null;
    case 'time':
      return renderTimeText({ mode: options.mode, t, time });
  }
};

export default WidgetItemTimeText;
